import { render, staticRenderFns } from "./authorizationshop-list.vue?vue&type=template&id=c9e57414"
import script from "./authorizationshop-list.vue?vue&type=script&lang=ts"
export * from "./authorizationshop-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports